import api from "@/lib/api";

let cache = null;
let pending = null;
let owner = null;

export function loadLexique(userId) {
  if (owner !== userId) { cache = null; pending = null; owner = userId; }
  if (cache) return Promise.resolve(cache);
  if (!pending) pending = api.get("/dictee/lexique").then((r) => { cache = r.data.entries || []; return cache; }).catch(() => { pending = null; return []; });
  return pending;
}

export async function saveLexique(entries) {
  const { data } = await api.put("/dictee/lexique", { entries });
  cache = data.entries;
  return cache;
}

const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export function applyLexique(text, entries) {
  let out = text;
  for (const e of entries || []) {
    const src = e.dit || "";
    if (!src) continue;
    out = out.replace(new RegExp(`(?<![\\p{L}\\p{N}])${esc(src)}(?![\\p{L}\\p{N}])`, "giu"), e.ecrit);
  }
  return out;
}
